import { render, staticRenderFns } from "./DocumentForm.vue?vue&type=template&id=a1ae052e"
import script from "./DocumentForm.vue?vue&type=script&lang=ts"
export * from "./DocumentForm.vue?vue&type=script&lang=ts"
import style0 from "./DocumentForm.vue?vue&type=style&index=0&id=a1ae052e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports